import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApiService } from '../service/api.service';
import { StorageService } from '../service/storage.service';
import { ToolsService } from '../service/tools.service';
import { ViewComponent } from './view/view.component';
import { HomeComponent } from './home/home.component';
import { AgmCoreModule } from '@agm/core';

@NgModule({
  declarations: [
    AppComponent,
    ViewComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCGKcsZcTyTuqOl0Yre1DF77thFg2ezuy4'
    })
  ],
  providers: [
    ApiService,
    StorageService,
    ToolsService
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/DEV/angular/web-track-correios/src/app/app.module.ts